module.exports = __webpack_public_path__ + "fonts/SuisseIntl-ThinItalic.ffafe4f.woff";